import { httpClient } from "../http/httpClient";

export interface MakeProposalPayload {
  nome: string;
  cpf: string;
  nascimento: string;
  telefone?: string;
  ocupacaoId: number;
  cep: string;
  pin?: string;
}

export interface MakeProposalResponse {
  propostaId: string;
}

export async function makeProposal(payload: MakeProposalPayload) {
  const { data } = await httpClient
    .post<MakeProposalResponse>("/crefaz", payload)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
